import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './core/guards/auth.guard';
import { CanManageUsersGuard } from './core/guards/can-manage-users.guard';
import { InitialFetchGuard } from './core/guards/initial-fetch.guard';
import { AppShellComponent } from './core/shell/shell.component';

const routes: Routes = [
  {
    path: '',
    component: AppShellComponent,
    canActivate: [AuthGuard, InitialFetchGuard],
    pathMatch: 'prefix',
    children: [
      {
        path: 'dashboard',
        loadChildren: async () => (await import('./modules/dashboard/dashboard.module')).DashboardModule,
      },
      {
        path: 'parking',
        loadChildren: async () => (await import('./modules/parking/parking.module')).ParkingModule,
      },
      {
        path: 'control',
        loadChildren: async () => (await import('./modules/control/control.module')).ControlModule,
      },
      {
        path: 'docs',
        loadChildren: async () => (await import('./modules/docs/docs.module')).DocsModule,
      },
      {
        path: 'administrators',
        canActivate: [CanManageUsersGuard],
        loadChildren: async () => (await import('./modules/administrators/administrators.module')).AdministratorsModule,
      },
    ],
  },
  { path: '**', redirectTo: '' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
  providers: [AuthGuard],
})
export class AppRoutingModule {}
